import axios from "axios";
import config from '../config.js';

export async function newActivity(userID,jwt, _filename, _size, _type, _service) {

    const dataForm = new FormData();
    dataForm.append('data', JSON.stringify({
        filename: _filename,
        size: _size,
        user: userID,
        type: _type,
        service: _service
    }))
    axios.post(`${config.apiUrl}/api/activities`, dataForm, {
        headers: {
            Authorization: `Bearer ${jwt}`,
        }
    }).then(res => {
        console.log(res);
    }).catch(err => {
        console.log(err);
    });
}

export async function getActivities(id,jwt) {
    let allActivities = [];
    let page = 1;
    let hasMoreData = true;
    
    while (hasMoreData) {
        let res = await axios.get(`${config.apiUrl}/api/activities?populate=*&pagination[page]=${page}&pagination[pageSize]=100`, {
            headers: {
                Authorization: `Bearer ${jwt}`,
            },
        });
        
        const activities = res.data.data;
        allActivities = allActivities.concat(activities);
        
        const pagination = res.data.meta.pagination;
        hasMoreData = page < pagination.pageCount;
        page++;
    }
    
    const filteredActivities = allActivities.filter(item => {
        const userData = item?.attributes?.user?.data;
        if (!userData) {
            return false;
        }
        return userData.id === id;
    });
    return filteredActivities;
}
